import { execAdmin } from '@src/apis/reware/utils';
import type {
  InitiatePricingMutation,
  InitiatePricingMutationVariables,
} from '@src/types/__generated/rewareAdminTypes';

const gql = String.raw;

/**
 * Initiates pricing rule processing for a partner.
 * This starts a background job that applies the pricing rules to catalog items.
 * Returns the timestamp when the job was initiated.
 */
export const initiatePricing = async ({
  partnerId,
  pricingType,
}: InitiatePricingMutationVariables) => {
  const query = gql`
    mutation initiatePricing(
      $partnerId: Int!
      $pricingType: String!
    ) {
      partner(id: $partnerId) {
        initiatePricing(pricingType: $pricingType)
      }
    }
  `;

  const data = await execAdmin<InitiatePricingMutationVariables, InitiatePricingMutation>(
    query,
    { variables: { partnerId, pricingType } }
  );

  const result = data.partner?.initiatePricing;
  if (!result) {
    throw new Error(
      `initiatePricing: unexpected response — partner.initiatePricing is ${result === null ? 'null' : 'undefined'} (partnerId=${partnerId}, pricingType=${pricingType})`
    );
  }

  return result;
};
